import Colors from 'assets/Colors';
import Funcs from 'common/helpers/Funcs';
import UIConst from 'consts/UIConst';
import React from 'react';
import { ActivityIndicator, FlatList, FlatListProps, Platform, RefreshControl, StyleSheet, View } from 'react-native';
import AntDesign from 'react-native-vector-icons/AntDesign';
import Octicons from 'react-native-vector-icons/Octicons';
import BaseButton from '../bases/BaseButton';
import BaseText from '../bases/BaseText';

export default class StaticFlatlist extends React.Component<FlatListProps> {
  static defaultProps = {
    emptyText: 'Empty',
    data: [],
    itemsPerPage: 20,
    disableRefresh: false,
    disablePagination: false
  };

  constructor(props) {
    super(props);
    this.page = 0;
    this.state = { data: null };
  }

  async componentDidMount() {
    this.page = 0;
    this.endOfList = false;
    this.loadMore();
    if (Platform.OS === 'android') {
      await Funcs.delay(1000);
      this.loadMore();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.data && this.props.data !== nextProps.data) {
      this.page = 0;
      this.endOfList = false;
      this.loadMore(nextProps.data);
    }
    return this.state.data !== nextState.data || this.state.key !== nextState.key || this.props.refreshing !== nextProps.refreshing;
  }

  loadMore = (data) => {
    const sourceData = data || this.props.data;
    data = sourceData?.data || sourceData || [];
    const { itemsPerPage, disablePagination } = this.props;
    const length = data?.length;
    if (length < 1) {
      this.setState({ data: null });
      return;
    }
    if (disablePagination) {
      this.setState({ data });
      return;
    }
    let totalPage = length / itemsPerPage;
    Funcs.log('Total page', totalPage, 'current page', this.page);
    if (this.page >= totalPage) {
      if (this.page === 0) this.setState({ data: [] });
      return;
    }

    // Offset
    let start = itemsPerPage * this.page;
    let end = start + itemsPerPage;
    if (end >= length) end = length;

    // New data
    let newData = data.slice(start, end);
    let currentData = this.page === 0 ? [] : this.state.data;
    this.setState({ data: [...currentData, ...newData] });

    // Increase page
    this.page++;
  };

  onLoadMore = () => {
    if (this.props.disablePagination) return;
    this.loadMore();
  };

  onPressReload = () => {
    if (this.props.onRefresh) this.props.onRefresh();
  };

  renderItem = ({ item, index }) => {
    let { renderItem } = this.props;
    if (!renderItem) return null;
    return renderItem({ item, index });
  };

  renderLoadingMore = () => {
    if (this.props.data?.length < 1 || this.state.data?.length >= this.props.data?.length) return null;
    return <ActivityIndicator size={'small'} style={styles.indicatorLoading} />;
  };

  render() {
    let { data } = this.state;
    let { emptyText, disableRefresh, contentContainerStyle } = this.props;
    if (emptyText && data?.length < 1) {
      return (
        <View style={styles.containerEmpty}>
          {this.props.onRefresh ? (
            <BaseButton style={styles.buttonReload} onPress={this.onPressReload}>
              <AntDesign name={'reload1'} size={UIConst.SCALE * 24} color={Colors.text} />
            </BaseButton>
          ) : (
            <Octicons name={'circle-slash'} size={UIConst.SCALE * 24} color={Colors.text} />
          )}
          <BaseText style={styles.textEmpty}>{emptyText}</BaseText>
        </View>
      );
    }
    return (
      <FlatList
        extraData={this.props}
        ListFooterComponent={this.renderLoadingMore}
        {...this.props}
        ref={(ref) => (this.FlatList = ref)}
        data={data}
        keyExtractor={this.props.keyExtractor || ((item, index) => index.toString())}
        renderItem={this.renderItem}
        onEndReached={this.onLoadMore}
        onEndReachedThreshold={0.5}
        contentContainerStyle={[styles.containerContent, contentContainerStyle]}
        refreshControl={
          !disableRefresh ? (
            <RefreshControl
              refreshing={this.props.refreshing}
              onRefresh={this.props.onRefresh}
              // title="Pull to refresh"
              tintColor={Colors.text}
              titleColor={Colors.text}
            />
          ) : null
        }
      />
    );
  }
}

const styles = StyleSheet.create({
  containerEmpty: {
    flex: 1,
    alignItems: 'center',
    margin: 10
  },
  textEmpty: {
    textAlign: 'center'
  },
  indicatorLoading: {
    marginVertical: 10
  },
  containerContent: {
    paddingVertical: 5
  },
  buttonReload: {
    padding: 5,
    margin: 5
  }
});
